// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Type of PartitionKey i.e. Hash, MultiHash
 */
export enum PartitionKeyKind {
  Hash = "Hash",
  MultiHash = "MultiHash",
}
